// Sentry Tag Keys
export const SENTRY_SCHOOL_NAME = 'sparx.school.name';
export const SENTRY_SCHOOL_DISPLAY_NAME = 'sparx.school.display_name';
